import {
  ConsultaSeguimentoPergunta11ExemplosEnum,
  ConsultaSeguimentoPergunta11Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-11/model-consultaSeguimentoPergunta11'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { convertToPassouFalhou, HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta11Model {
  header: MchatRfAplicacaoQueryModel
  exemplosPassou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  exemplosFalhou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  perguntaMaiorFrequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta11Model
}

export const convertAplicacaoPergunta11 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta11Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_11_01)
  const perguntaMaiorFrequencia = aplicacoes.find(
    (aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_11_08
  )
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_11_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_11_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))
  if (header == undefined) return null

  return {
    header,
    exemplosPassou,
    exemplosFalhou,
    perguntaMaiorFrequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_11_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_11_EXEMPLOS: {
        PASSOU: convertAplicacoesToExemplos(exemplosPassou),
        FALHOU: convertAplicacoesToExemplos(exemplosFalhou),
      },
      PERGUNTA_11_FREQUENCIA: convertToPassouFalhou(perguntaMaiorFrequencia?.stPassou),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta11ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta11ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const PERGUNTA_11_EXEMPLOS_PASSOU = [
  MChatPerguntaEnum.PERGUNTA_11_02,
  MChatPerguntaEnum.PERGUNTA_11_03,
  MChatPerguntaEnum.PERGUNTA_11_04,
]

const PERGUNTA_11_EXEMPLOS_FALHOU = [
  MChatPerguntaEnum.PERGUNTA_11_05,
  MChatPerguntaEnum.PERGUNTA_11_06,
  MChatPerguntaEnum.PERGUNTA_11_07,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta11ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_SORRI]: undefined,
  [ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO]: undefined,
  [ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_VOLTA]: undefined,
  [ConsultaSeguimentoPergunta11ExemplosEnum.ESTA_SEMPRE_SORRINDO]: undefined,
  [ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_PARA_BRINQUEDO_OU_ATIVIDADE]: undefined,
  [ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_AO_ACASO_OU_SEM_MOTIVO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta11ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_11_02]: ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_SORRI,
  [MChatPerguntaEnum.PERGUNTA_11_03]: ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO,
  [MChatPerguntaEnum.PERGUNTA_11_04]: ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_QUANDO_VOCE_VOLTA,
  [MChatPerguntaEnum.PERGUNTA_11_05]: ConsultaSeguimentoPergunta11ExemplosEnum.ESTA_SEMPRE_SORRINDO,
  [MChatPerguntaEnum.PERGUNTA_11_06]: ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_PARA_BRINQUEDO_OU_ATIVIDADE,
  [MChatPerguntaEnum.PERGUNTA_11_07]: ConsultaSeguimentoPergunta11ExemplosEnum.SORRI_AO_ACASO_OU_SEM_MOTIVO,
}
